import angular from 'angular'

import template from '../../../templates/cash-management/wr-cash-float-not-set.html'

/**
 * Directive for showing an error message to highlight that a cash float has not been set. Also allow's the retailer to
 * set a cash float.
 *
 * @module webregister.directives.wrCashFloatNotSet
 */
angular
  .module('webregister.directives')
  .directive('wrCashFloatNotSet', function () {
    return {
      scope: {
        onCashFloatSet: '&?',
      },
      restrict: 'E',
      template,
      bindToController: true,
      controllerAs: 'cashFloatNotSetCtrl',

      /**
       * =======================================
       * CASH FLOAT NOT SET CONTROLLER
       * =======================================
       */
      controller(this: $TSFixMe, cashManagementModals) {
        /**
         * Show the open register set float modal.
         *
         * @method setCashFloat
         */
        this.setCashFloat = function () {
          cashManagementModals.openRegisterSetFloat().then(() => {
            if (angular.isFunction(this.onCashFloatSet)) {
              this.onCashFloatSet()
            }
          })
        }
      },
    }
  })
